import Vant from './Vant'

const components = [
  Vant
]

export default () => {
  components.forEach((item) => {
    item()
  })
}